/** @jsx jsx */
import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import {UnconnectedReturnButton} from '@instructure/quiz-core/common/components/shared/return_button/ReturnButton'
import {jsx} from '@instructure/emotion'
import {withStyleOverrides} from '@instructure/quiz-common/util/withStyleOverrides'
import t from 'format-message'

import RespondusCommandButton from '../RespondusCommandButton'
import generateStyle from './styles'
import generateComponentTheme from './theme'

class ReturnButtonContainerUnstyled extends React.Component {
  static displayName = 'ReturnButtonContainer'
  static componentId = 'QuizzesReturnButtonContainer'

  static propTypes = {
    platform: PropTypes.string,
    returnToUrl: PropTypes.string,
    rldbLaunch: PropTypes.bool,
    rldbCanExit: PropTypes.bool,
    iceTopNavBarEnabled: PropTypes.bool,
    makeStyles: PropTypes.func,
    styles: PropTypes.object,
    isHorizon: PropTypes.bool,
  }

  static defaultProps = {
    platform: void 0,
    returnToUrl: void 0,
    rldbLaunch: false,
    rldbCanExit: false,
    iceTopNavBarEnabled: false,
  }

  componentDidMount() {
    this.props.makeStyles()
  }

  componentDidUpdate() {
    this.props.makeStyles()
  }

  get isMobile() {
    return 'mobile ios android'.split(' ').includes(this.props.platform)
  }

  get isMissingReturnUrl() {
    return this.props.returnToUrl == 'false'
  }

  get hidesReturnButton() {
    return this.isMobile || this.isMissingReturnUrl
  }

  render() {
    if (!this.props.styles.showReturnButton) {
      return null
    }

    const {rldbLaunch, rldbCanExit} = this.props

    if (rldbLaunch && rldbCanExit) {
      return (
        <div css={this.props.styles.returnButtonContainer}>
          <RespondusCommandButton
            buttonLabel={t('Exit')}
            command="exit"
            iceTopNavBarEnabled={this.props.iceTopNavBarEnabled}
          />
        </div>
      )
    } else if (this.hidesReturnButton || rldbLaunch) {
      return null
    }

    return (
      <div css={this.props.styles.returnButtonContainer}>
        <UnconnectedReturnButton
          isHorizon={this.props.isHorizon}
          returnToUrl={this.props.returnToUrl}
          text={t('Return')}
          iceTopNavBarEnabled={this.props.iceTopNavBarEnabled}
        />
      </div>
    )
  }
}

export function mapStateToProps({context}) {
  const horizonCourse = context.horizonCourse
  const horizonAccount = context.horizonAccount
  return {
    isHorizon: horizonCourse || horizonAccount,
  }
}

export const UnconnectedReturnButtonContainer = withStyleOverrides(
  generateStyle,
  generateComponentTheme,
)(ReturnButtonContainerUnstyled)

export const ReturnButtonContainer = connect(mapStateToProps)(UnconnectedReturnButtonContainer)

export default ReturnButtonContainer
